const SpinModule = () => import(/* webpackChunkName: "spin-module" */ './views/Module.vue');
const SpinWheelHistory = () => import(/* webpackChunkName: "SpinWheelHistory" */ './views/SpinWheelHistory.vue');

const SpinRoutes = {
    path: '/',
    component: SpinModule,
    children: [
        {
            path: "/spin-wheel-history",
            name: "SpinWheelHistory",
            component: SpinWheelHistory
        },
    ],
}

export default SpinRoutes;